var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7152 18.9589C6.3819 18.9589 2.86523 15.4339 2.86523 11.1089C2.86523 9.55052 3.32357 8.04219 4.19023 6.74219C4.3819 6.45885 4.77357 6.37552 5.0569 6.56719C5.34023 6.75885 5.42357 7.15052 5.2319 7.43385C4.5069 8.51719 4.12357 9.79219 4.12357 11.1005C4.12357 14.7422 7.0819 17.7005 10.7236 17.7005C14.3652 17.7005 17.3236 14.7422 17.3236 11.1005C17.3236 7.45885 14.3569 4.50052 10.7152 4.50052C9.94857 4.50052 9.19857 4.60885 8.49023 4.82552C8.1569 4.92552 7.8069 4.74219 7.7069 4.40885C7.6069 4.07552 7.79024 3.72552 8.12357 3.62552C8.9569 3.37552 9.82357 3.24219 10.7152 3.24219C15.0486 3.24219 18.5652 6.76719 18.5652 11.0922C18.5652 15.4172 15.0486 18.9589 10.7152 18.9589Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27413 5.05811C7.13246 5.05811 6.98246 5.00811 6.86579 4.90811C6.59913 4.67477 6.57413 4.28311 6.79913 4.02477L9.20746 1.25811C9.43246 0.999775 9.83246 0.966442 10.0908 1.19978C10.3491 1.42478 10.3741 1.82478 10.1491 2.08311L7.74079 4.84144C7.61579 4.98311 7.44079 5.05811 7.27413 5.05811Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0818 7.11007C9.95682 7.11007 9.82348 7.0684 9.71515 6.9934L6.89848 4.93507C6.62348 4.73507 6.56515 4.3434 6.76515 4.0684C6.96515 3.78507 7.35682 3.72673 7.64015 3.92673L10.4485 5.97673C10.7235 6.17673 10.7902 6.5684 10.5818 6.85173C10.4652 7.02673 10.2735 7.11007 10.0818 7.11007Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetButton);
export default __webpack_public_path__ + "static/media/reset-button.c53bc4a198fc2ce6e29b8069862c9af8.svg";
export { ForwardRef as ReactComponent };